export enum MODAL {
  TEST = 'test',
  PROFILE_EDITOR = 'ProfileEditor',
  CLIENT_SEARCH = 'ClientSearch',
  CLIENT_EDITOR = 'ClientEditor',
  COMPANIES = 'CompaniesEditor',
  PRICE_CHANGE = 'OfferPriceChanges',
  PRINT_BASE = 'PrintBase',
  MAIL_TEMPLATE_EDITOR = 'MailTemplateEditor',
  MAIL_TEMPLATE_DELETION = 'MailTemplateDelete',
  QUOTE_SAVE = 'QuoteCreate',
  EVB_MODAL = 'EVBModal',
  GENERIC_INFO_MODAL = 'FormElementWithModal',
  USER_SETTINGS = 'UserSettings',
  INPUT_MAPPING = 'InputMapping',
  PREVIOUS_INSURANCE_TARIFF_SELECTION = 'previousInsuranceTariffSelection',
  GKV_COMPANY_OVERVIEW = 'gkvCompanyOverview',
  CHILD_PROFESSION_BIRTHDATE = 'childProfessionBirthdate',
  CONFIDENTIALITY_AGREEMENT_HINTS = 'confidentialityAgreementHints',
  COMPLEX_SELECT = 'complexSelect',
  VERSICHERUNGSANGABEN = 'versicherungsangaben',
  CONTRACT_FILES = 'contractFiles',
  OFFER = 'offer',
}
